import React from "react";
import { useTranslation } from "react-i18next";
import usePastTripSummaryView from "./past-trip-summary/usePastTripSummaryView";
import PastTripSummaryInsights from "./past-trip-summary/PastTripSummaryInsights";
import PastTripSummaryFilters from "./past-trip-summary/PastTripSummaryFilters";
import PastTripSummaryGallery from "./past-trip-summary/PastTripSummaryGallery";
import {
  PastTripMemories,
  PastTripRecordedBreakdowns,
  PastTripResultCards,
} from "./past-trip-summary/PastTripReportSections";

export default function PastTripSummaryPanel({
  trip,
  summary,
  loading,
  error,
  weatherConditions,
  analyticsView,
  setAnalyticsView,
  analyticsFilters,
  setAnalyticsFilters,
  onOpenInfo,
  onOpenMedia,
  onOpenAddCatch,
}) {
  const { t } = useTranslation();
  const pastSummary = usePastTripSummaryView({
    trip,
    summary,
    weatherConditions,
    analyticsView,
    setAnalyticsView,
    analyticsFilters,
    setAnalyticsFilters,
  });

  return (
    <div className="mytrips-past-summary">
      <div className="mytrips-past-summary-header">
        <div>
          <h3 className="mytrips-past-summary-title">
            {t("trip_catch_library", {
              defaultValue: "Trip Catch Library",
            })}
          </h3>
          <p className="mytrips-past-library-subtitle">
            {t("trip_report_library_subtitle")}
          </p>
        </div>
        <div className="mytrips-past-summary-header-actions">
          {summary?.matchedCount > 0 && (
            <span className="mytrips-past-summary-count">
              {summary.matchedCount}{" "}
              {t("trip_catches_label", {
                defaultValue: "catches",
              })}
            </span>
          )}
          <button
            type="button"
            className="mytrips-past-summary-action"
            onClick={onOpenAddCatch}
          >
            {t("trip_add_catch_action", {
              defaultValue: "Add Catch",
            })}
          </button>
        </div>
      </div>

      {!loading && !error ? (
        <PastTripResultCards pastSummary={pastSummary} />
      ) : null}

      {loading ? (
        <p className="mytrips-past-summary-state">
          {t("trip_past_summary_loading", {
            defaultValue: "Loading catch summary...",
          })}
        </p>
      ) : error ? (
        <p className="mytrips-past-summary-state mytrips-past-summary-state-error">
          {error}
        </p>
      ) : pastSummary.summaryItems.length === 0 ? (
        <p className="mytrips-past-summary-state">
          {t("trip_past_summary_empty", {
            defaultValue: "No catches matched this trip yet.",
          })}
        </p>
      ) : (
        <>
          <PastTripSummaryInsights
            pastSummary={pastSummary}
            weatherConditions={weatherConditions}
          />
          <PastTripSummaryFilters
            pastSummary={pastSummary}
            analyticsFilters={analyticsFilters}
            analyticsView={analyticsView}
          />
          <PastTripSummaryGallery
            items={pastSummary.summaryItems}
            onOpenMedia={onOpenMedia}
            onOpenInfo={onOpenInfo}
          />
          <PastTripRecordedBreakdowns pastSummary={pastSummary} />
        </>
      )}

      {!loading && !error ? <PastTripMemories trip={trip} /> : null}
    </div>
  );
}
